(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickDetailController', BrickDetailController);

    BrickDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Brick'];

    function BrickDetailController($scope, $rootScope, $stateParams, entity, Brick) {
        var vm = this;
        vm.brick = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:brickUpdate', function(event, result) {
            vm.brick = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
